export enum BRACKETS {
  shuffle = 'shuffle',
  rbg = 'rbg',
  blitz = 'blitz',
  '3v3' = '3v3',
  '2v2' = '2v2',
  'multiclassers' = 'multiclassers',
}
